import { ExamCenterCreationButton } from '@exam-center/exam-center-creation';
import { ExamCenterList } from '@exam-center/exam-center-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, Paper, Text } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminExamCentersPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.MEMBER.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <Flex sx={{ p: (theme) => theme.spacing(6), justifyContent: 'space-between' }}>
          <Text variant='h1'>ศูนย์ทดสอบ</Text>
          <ExamCenterCreationButton />
        </Flex>
        <Flex sx={{ flex: 1, p: (theme) => theme.spacing(6) }}>
          <Paper sx={(theme) => ({ width: '100%', p: theme.spacing(6) })}>
            <ExamCenterList />
          </Paper>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
